import React from 'react';
import PropTypes from 'prop-types';
import { StyledButton as Btn } from './SortableTable.styles';
import { UserCtx } from '../../../contexts/UserCtx';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

/**
 * Like styles.StyledButton, but also supports reqPermission:string to disable if the current
 * user does not have permission to use
 * @param {*} props
 * @returns
 */
export function StyledButton(props) {
  const { reqPermission, children } = props;

  // If a permission is required, check the user has it
  const passThroughProps = { ...props };
  if (reqPermission !== undefined) {
    const userCtx = React.useContext(UserCtx);
    const denyReason = userCtx.denyReason(reqPermission);
    if (denyReason !== undefined) {
      passThroughProps.title = denyReason;
      passThroughProps.disabled = true;
    }
  }

  return <Btn {...passThroughProps}>{children}</Btn>;
}

StyledButton.propTypes = {
  children: ReactChildrenPropType.isRequired,
  /**
   * Permission required to activate the button (otherwise disabled)
   * If undefined, no permission is required
   */
  reqPermission: PropTypes.string
};

StyledButton.defaultProps = {
  reqPermission: undefined
};
